// extracted by css-extract-rspack-plugin
export default {"MilestoneFilterItem":"ItemPickerMilestone-module__MilestoneFilterItem__vcbkC","MilestoneItem":"ItemPickerMilestone-module__MilestoneItem__Rugex"};